import { createAction } from 'redux-actions';
import { pushModal } from '../../Modals/redux/actionCreators';
import { ModalType } from '../../Modals/redux/types';
export var openCommissionEditModal = function (params) {
    return pushModal(ModalType.COMMISSION, { params: params, wrapInModal: false });
};
export var createCommission = createAction('@@COMMISSIONS.CREATE', function (payload) { return payload; });
export var updateCommission = createAction('@@COMMISSION.UPDATE', function (payload) { return payload; });
export var changeCommissionStatus = createAction('@@COMMISSION.CHANGE_STATUS', function (payload) { return payload; });
export var changeCommissionStatusSuccess = createAction('@@COMMISSION.CHANGE_STATUS_SUCCESS', function (payload) { return payload; });
export var toggleCommissionStatus = createAction('@@COMMISSION.TOGGLE_STATUS', function (payload) { return payload; });
//# sourceMappingURL=actionCreators.js.map